import React , { Component } from 'react';
import Agent from "../../Network/Agent";
import ButtonPrimary from "../Elements/ButtonPrimary";
import {Link} from "react-router-dom";
import {getGeneratedRoute, RouteEnumFinal} from "../../Config/RouteEnum";
import ToolBar from "../Elements/ToolBar";
import BottomSheetAction from "../Elements/BottomSheet/BottomSheetAction";
import BottomSheetConfirm from "../Elements/BottomSheet/BottomSheetConfirm";
import {ActionButtonsEnum} from "../Elements/BottomSheet/Enum/ActionButtonsEnum";



class AddressList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            storeUsername : window.location.pathname.split('/')[1],
            buttonLoading : false,
            addresses : [],
            modal : {
                actions : false,
                confirm : false,
            },
            address : '' ,
            temporaryData : '',
            isLoading : {
                confirm : false
            },
        }
    }

    toggleModal = (target) => e => {
        let modal = this.state.modal
        modal[target] = !modal[target]
        this.setState({
            modal
        })
    }

    setCodeToBS = (address) => e => {
        // this.toggleModal('actions')
        // console.log(code)
        this.setState({
            modal : {
                actions : true
            },
            address : address
        })
    }

    onBottomSheetCallBack = (type , data) => {
        console.log(type , data)
        if (type === 'edit') {
            window.location = getGeneratedRoute(RouteEnumFinal.ADDRESS_EDIT_URL_GENERATE , this.state.storeUsername , data)
        }
        if (type === 'delete') {
            this.setState({
                modal : {
                    confirm : true
                } ,
                temporaryData : this.state.address.title
            })
        }
    }
    onBottomSheetConfirmCallBack = (type , data) => {
        console.log(type , data)

        if (type === 'positive') {
            this.setState({
                isLoading : {
                    confirm : true
                }
            })
            Agent.Address.delete(data)
                .then(response => {
                    this.setState({
                        modal : {
                            confirm : false
                        },
                        isLoading : {
                            confirm : false
                        }
                    })
                    this.getAddressList()
                })
                .catch(error => {
                    console.log(error.response)
                })
        }
    }

    getAddressList = () => {
        Agent.Address.list()
            .then(response => {
                this.setState({
                    addresses : response.data.result.addresses
                })
            })
            .catch(error => {
                console.log(error.response)
            })
    }

    componentDidMount() {

        this.getAddressList()
    }

    test = () => {

    }

    render() {
        return(
            <>
                <ToolBar title={"آدرس ها"} url={getGeneratedRoute(RouteEnumFinal.STORE_PANEL_URL_GENERATE)} />

                <div className='container'>
                    <div className='row'>
                        {
                            this.state.addresses.map(address => {
                                return(
                                    <div key={address.code} className='col-12' onClick={this.setCodeToBS(address)}>
                                        <div className='mt-20'>
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <div className='mobile-h4 cl-black'>
                                                    {address.title}
                                                </div>
                                                <div className='img-cnt-24'>
                                                    <img src={"/assets/images/vectors/more_gray.svg"}/>
                                                </div>
                                            </div>
                                            <div className='mobile-subtitle-regular cl-black mt-12'>
                                                {address.address}
                                            </div>
                                            <div className='row g-3 mt-8'>
                                                <div className='col-6'>
                                                    <div className='mobile-body-2-regular cl-subtitle'>
                                                        مکان :
                                                        {address.province.title.concat('، ')}
                                                        {address.county.title}
                                                    </div>
                                                </div>
                                                <div className='col-6'>
                                                    <div className='mobile-body-2-regular cl-subtitle'>
                                                        شماره تماس :
                                                        {address.phoneNumber}
                                                    </div>
                                                </div>
                                                <div className='col-6'>
                                                    <div className='mobile-body-2-regular cl-subtitle'>
                                                        گیرنده  :
                                                        {address.receiver}
                                                    </div>
                                                </div>
                                                <div className='col-6'>
                                                    <div className='mobile-body-2-regular cl-subtitle'>
                                                        پلاک :
                                                        {address.zipCode}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='divider-1px bg-gray-custom-1 mt-12'/>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

                <BottomSheetAction show={this.state.modal.actions}
                                   onHide={this.toggleModal('actions')}
                                   data={this.state.address.code}
                                   buttons={[
                                       ActionButtonsEnum.DELETE ,
                                       ActionButtonsEnum.EDIT ,
                                   ]}
                                   action={this.onBottomSheetCallBack} />

                <BottomSheetConfirm show={this.state.modal.confirm}
                                    onHide={this.toggleModal('confirm')}
                                    title={"حذف آدرس "+this.state.address.title}
                                    body='آیا از حذف این آدرس اطمینان دارید ؟'
                                    data={this.state.address.code}
                                    action={this.onBottomSheetConfirmCallBack}
                                    isLoading={this.state.isLoading.confirm}
                                    btnText='حذف' />

                <div className='scroll-fixer'/>
                <div className='btn-fixed-bottom'>
                    <Link to={getGeneratedRoute(RouteEnumFinal.ADDRESS_ADD_URL_GENERATE , this.state.storeUsername)} className='td-none' >
                        <ButtonPrimary mode='dark-mode' text='آدرس جدید' isLoading={this.state.buttonLoading} />
                    </Link>
                </div>
            </>
        )
    }
}


export default AddressList